
const questions = {
    "reportGuid": null,
    "categories": [
        {
            "categoryName": "Intimacy",
            "categoryDescription": "1 = Strongly disagree, 2 = Somewhat disagree, 3 = Neutral, 4 = Somewhat agree, 5 = Strongly agree",
            "data": [
                {
                    "name": "I have been spiritually intimate with my spouse",
                    "description": "Pursuing Jesus and his kingdom together",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "I have been emotionally intimate with my spouse",
                    "description": "Understanding each other's feelings, seeking to know one another, romance",
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "I have been physically intimate with my spouse",
                    "description": "Delighting in physical and sex",
                    "answer": null,
                    "answerType": 2
                }
                
            ]
        },
        {
            "categoryName": "Communication",
            "categoryDescription": "My spouse and I have been on the same page regarding the following:",
            "data": [
                {
                    "name": "Schedules",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Meal planning",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Household chores",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Parenting",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Budgeting and spending",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Hospitality",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Recreation and fun",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                },
                {
                    "name": "Long term vision and goals",
                    "description": null,
                    "answer": null,
                    "answerType": 3
                }
                
            ]
        },
        {
            "categoryName": "Spiritual Life",
            "categoryDescription": "On a scale of 1 to 5, rate the following:  (1 = Failing, 3 = Coasting, 5 = Excellent)",
            "data": [
                {
                    "name": "Consistency of my private prayers for my spouse",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in prayer as a couple",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency (and quality) of family worship",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency of hospitality and kingdom work - spending our time and resources for those outside the home",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        {
            "categoryName": "Love-making",
            "categoryDescription": "1 = Strongly disagree, 2 = Somewhat disagree, 3 = Neutral, 4 = Somewhat agree, 5 = Strongly agree",
            "data": [
                {
                    "name": "I am very satisifed with our flirting and foreplay",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "I am very satisfied with the consistency of our sex",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "I am very satisfied with the quality of our sex",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        {
            "categoryName": "Parenting",
            "categoryDescription": "On a scale of 1 to 5, how am I doing with the following? (1 = Failing, 3 = Coasting, 5 = Excellent)",
            "data": [
                {
                    "name": "Clearly communicating expectations to the children",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in discipline and correction",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Correcting in love without anger or frustration",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Consistency in encouragement and affirmations towards the children",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                },
                {
                    "name": "Focus on each child's spiritual growth and needs",
                    "description": null,
                    "answer": null,
                    "answerType": 2
                }
            ]
        },
        {
            "categoryName": "Forgiveness and Appreciation",
            "categoryDescription": "Leave blank if not applicable",
            "data": [
                {
                    "name": "Some thing(s) that you did that hurt me",
                    "description": null,
                    "answer": null,
                    "answerType": 1
                },
                {
                    "name": "Some thing(s) I need to ask forgiveness for",
                    "description": null,
                    "answer": null,
                    "answerType": 1
                },
                {
                    "name": "Some thing(s) I appreciate about my spouse",
                    "description": null,
                    "answer": null,
                    "answerType": 1
                }
            ]
        },
        {
            "categoryName": "Summary",
            "categoryDescription": "Last comments",
            "data": [
                {
                    "name": "Comments",
                    "description": "Anything else you want to add?",
                    "answer": null,
                    "answerType": 1
                }
            ]
        }
    ]
}

module.exports = questions;